import { BasicCard, CardHeader } from "../common/styles";
import { CollectionBanner } from "../discovery/CardBanner";
import { collectionPath } from "common/src/routes/explorer";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const CollectionCard = _ref => {
  let {
    collection,
    size
  } = _ref;
  const {
    cid,
    name,
    description
  } = collection;
  const sliceLength = size === "small" ? 165 : 385;
  let desc = description;
  if (description && description.length > sliceLength) {
    desc = description.slice(0, sliceLength) + "...";
  }
  return /*#__PURE__*/_jsx(BasicCard, {
    className: "w-full h-[246px]",
    children: /*#__PURE__*/_jsxs("a", {
      href: collectionPath(cid),
      "data-track-event": `home-collections-card-${size}`,
      children: [/*#__PURE__*/_jsx(CardHeader, {
        children: /*#__PURE__*/_jsx(CollectionBanner, {})
      }), /*#__PURE__*/_jsxs("div", {
        className: "p-4 space-y-1",
        children: [/*#__PURE__*/_jsx("div", {
          className: "font-medium truncate text-xl",
          children: name
        }), /*#__PURE__*/_jsx("p", {
          className: "text-grey-400 text-sm",
          children: desc
        })]
      })]
    })
  });
};
export default CollectionCard;